import React from "react";
import { Outlet } from "react-router-dom";

//FUNCTION
const EcommerceRoutes = () => {
    return (
        <>
            <Outlet />
        </>
    )
}

export default EcommerceRoutes;